export const posts = [
   
  {
    id: 1,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/1-IcyMonkey.gif",
    category: 'Explainer Animation',
    name: "Icy Monkey",
    url: "/post1",
    description:
      "This project aims to create an engaging and visually stunning 3D motion graphic video for Icy Monkey. The goal is to showcase the brand's unique offerings while capturing its playful and refreshing essence. The final product will be utilized for marketing purposes on the company’s website and social media platforms.",
    src: "https://drive.google.com/file/d/1FlF8zImm81gGnIJuns8zKf808sbC9zsl/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/IcyMonkey/7.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/IcyMonkey/Animatic.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/IcyMonkey/IcyMonkey2.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/IcyMonkey/Matchcut.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/IcyMonkey/Start.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/IcyMonkey/Viberts-models.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/IcyMonkey/pagetwocopy.jpg'
    },
    creators:{
      A: "Client: Icy Monkey",
      B: "Studio: Beesider",
      C: "Supervisor: Amir Koji",
      D: "Art Director: Reza Behnamian", 
      E: "Concept Artist: Reza Behnamian",
      F: "Frame By Frame: Reza Behnamian",
      G: "3D Artist: Ali Ebrahimi",
      H: "3D Artist Junior: Atefe Fazeli, Vahid Hanid"
    }
  },
  /* {
    id: 2,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/Nessle.gif",
    category: 'Commercial',
    name: "Nestlé",
    url: "/post2",
    description:
      "This motion design project is a playful visual journey created in a hybrid 3D + 3D style. The story follows a tiny flying character animated in expressive 2D, as he travels through an imaginative universe built from fully 3D-modeled cakes, biscuits, and cupcakes.",
    src: "https://drive.google.com/file/d/129jUs0Y-PbgZxcwo__o0s5a3WzSdVB8h/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/Storyboard.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/Tagframe.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/Skyframe.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/transition.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/Character.jpg',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/FBF.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/Animatic.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nestle/Fly.gif',

    },
    creators:{
      A: "Client: Nestlé",
      B: "Art Director: Reza Behnamian",
      C: "Animation Supervisor: Vahid Hanid",
      D: "Animators: Atefe Fazeli, Vahid Hanid", 
      E: "Composition: Vahid Hanid",
      F: "3D Artist: Vahid Hanid, Mohammad Amin ",
      G: "Frame By Frame:Reza Behnamian, Arman Alipour",
      H: "Storyboard: Reza Behnamian",
      J: "Illustration: Reza Behnamian",
      K: "Composer: Amin Ranjbar"
    }
  }, */
  /* {
    id: 3,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Azki/Azki.gif",
    name: "AZKI",
    url: "/post3",
    description:
      "An animated brand video made for Azki, showcasing their insurance services through bold visuals and a simple message. The aim was to keep it modern, accessible, and easy to follow.",
    src: "https://drive.google.com/file/d/177T_QtZzVlJafRTuFn3XvlIg-nOrEBZE/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Azki/010_00000.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Azki/playing.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Azki/Transition.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Azki/Transition-mordab.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Azki/SkyCar.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Azki/Frog.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Azki/3d-Car.gif'
    },
    creators:{
      A: "Client: Azki",
      B: "Art Director: Reza Behnamian",
      C: "Animators: Atefe Fazeli ",
      D: "Composition: Vahid Hanid", 
      E: "3D Artist: Vahid Hanid, Mohsen Moradi , Amin ",
      F: "Frame By Frame: Reza Behnamian, Shohreh Hadipour , Arman Alipour",
      G: "Storyboard: Reza Behnamian",
      H: "Illustration: Reza Behnamian",
      I: "Sound Designer: Muhammad Amin"
    }
  }, */
  {
    id: 2,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/Pixelnetwork.gif",
    name: "Pixel Network",
    url: "/post2",
    description:
      "The Pixel Network project was designed with the goal of simplifying content and presenting it in the fastest possible way. By combining various techniques, it aimed to deliver information more clearly and accessibly. The use of color schemes and image simplification, methods made execution easier and highlighted the main subject of the story, resulting in clear and fast outputs for our team.",
    src: "https://drive.google.com/file/d/1VmUhjm7ubbm7nydJRRaveO5F4gOWq206/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/Storyboard.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/City.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/Up.png',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/concept.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/Car-icon.jpg',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/carmodel.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/character.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/PixelNetwork/popup.gif'
    },
    creators:{
        A: "Client: Pixel Network",
        B: "Art Director: Reza Behnamian",
        C: "Animation Supervisor: Atefe Fazeli",
        D: "Animators: Atefe Fazeli, Vahid Hanid",
        E: "Composition: Vahid Hanid",
        F: "3D Artist: Vahid Hanid, Mohammad Amin",
        G: "Manager: Samare Sadeghi",
        H: "Illustration: Reza Behnamian",
        I: "Composer: Amin Ranjbar"
    }
  },
  {
    id: 3,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Subify/Subify.gif",
    name: "Subify",
    url: "/post3",
    description:
      "This motion graphics piece was made for Subify to promote its smart e-commerce model. Designed with a smooth, minimal style to communicate value quickly and effectively.",
    src: "https://drive.google.com/file/d/16on8ND4j_7ZJXoiZH2GPiPbTY6g2EuBU/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Subify/Storyboard.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Subify/Dragging.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Subify/Phone.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Subify/Shooping.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Subify/Walking.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Subify/furiture.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Subify/mouse.gif'
    },
    creators:{
      A: "Client: Subify",
      B: "Animation Supervisor: Atefe Fazeli",
      C: "Animators: Vahid Hanid, Atefe Fazeli",
      D: "Composition: Vahid Hanid", 
      E: "3D Artist: Vahid Hanid ",
      F: "Frame By Frame: Reza Behnamian, Arman Alipour",
      G: "Storyboard: Reza Behnamian",
      H: "Illustration: Reza Behnamian",
      I: "Sound Designer: Muhammad Amin"
    }
  },
  /* {
    id: 6,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/Diwar.gif",
    name: "Divar",
    url: "/post6",
    description:
      "This explainer video was designed for Divar to introduce one of their latest app features.Simple visuals and smooth transitions were used to keep the focus on clarity and user benefits.",
    src: "https://drive.google.com/file/d/1Z-HpmrxnX5aNyD07f4zc1AdxVP3JKqyz/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/0010_00000.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/Click.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/Hourglasses.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/Nardebon.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/Slider.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/Star.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/Start.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Diwar/Tunnel.gif'
    },
    creators:{
      A: "Client: Divar",
      B: "Art Director: Reza Behnamian",
      C: "Animation Supervisor: Vahid Hanid ",
      D: "Animators: Arman Alipour , Atefe Fazeli", 
      E: "Composition: Vahid Hanid",
      F: "3D Artist: Atefe Fazeli",
      G: "Frame By Frame: Reza Behnamian",
      H: "Storyboard: Reza Behnamian",
      I: "Illustration: Reza Behnamian, Azam Torshizi",
      j:"Sound Designer: Muhammad Amin"
    }
  }, */
  /* {
    id: 7,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/3-Folad.gif",
    name: "Folad-1",
    url: "/post7",
    description:
    " This 2D Info graphic project will serve as a strategic asset for Folad Mobarakeh Steel Company, enhancing its communication efforts and fostering a deeper connection with its audience through vibrant storytelling and engaging visuals.",
 
    src: "https://drive.google.com/file/d/1u3pX74s9KCr8_SPQs7SIxcyWxV1KUhGJ/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-01/5.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-01/CameraLandscape.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-01/Characters.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-01/Papers.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-01/Sayhello.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-01/Top-car.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-01/WOrking.gif',
      },
      creators:{
        A: "Client: Folad Mobarakeh Steel Company",
        B: "Art Director: Reza Behnamian",
        C: "Animation Supervisor: Atefe Fazeli",
        D: "Animators: Atefe Fazeli , Vahid Hanid",
        E: "Composition: Mehrdad Rashidi",
        G: "Frame By Frame: Reza Behnamian",
        H: "Storyboard: Reza Behnamian",
        I: "Illustration: Reza Behnamian",
        J: "Sound Designer: Muhammad Amin",
      }
  },
  {
    id: 8,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/2-Folad.gif",
    name: "Folad-2",
    url: "/post8",
    description:
    "Create an engaging and informative 2D motion graphic animation that encapsulates the vision, values, and operational processes of Folad Mobarakeh Steel Company. The aim is to visualize the company's commitment to quality steel production, its technological advancements, and sustainable practices while appealing to both internal and external stakeholders",
 
    
    src: "https://drive.google.com/file/d/1bULZwhzNbDSoZRy4cMONkRepgYH4v41c/preview",
    images:{
      pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-02/4.png',
      pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-02/Airplan.gif',
      pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-02/Factory.gif',
      pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-02/Firstscene.gif',
      pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-02/Icons.gif',
      pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-02/Signal.gif',
      pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Folad-02/photo.jpg'

    },
    creators:{
      A: "Client: Folad Mobarakeh Steel Company",
      B: "Art Director: Reza Behnamian",
      C: "Storyboard and Iluustration: Reza Behnamian",
      D: "Animators: Shahryar TG,Atefe Fazeli",
      E: "3D Artist: Atefe Fazeli",
      F: "Composition: Vahid Hanid",
      G: "Sound Designer: Muhammad Amin",
      H: "Frame By Frame: Reza Behnamian",
    }
  }, */
  {
    id: 4,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/4-EconoPak.gif",
    name: "Econo Pak",
    url: "/post4",
    description:
      " To create an engaging and visually appealing 2D motion graphic that highlights the services and unique selling points of Econopack Premier Food Packaging Services. The animation will serve as an educational tool, promoting brand awareness and enhancing customer understanding of packaging solutions offered.",
    src: "https://drive.google.com/file/d/1RwajAkB9q0Wes_KYS2_Yxk1dZWAUxuoT/preview",
    images:{
      pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Econo-pack/1.png',
      pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Econo-pack/Car.gif',
      pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Econo-pack/FactoryFront.gif',
      pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Econo-pack/Sign-in.gif',
      pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Econo-pack/Typing.gif',
      pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Econo-pack/factory.JPG',
      pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Econo-pack/3dcar.gif'


    },
    creators:{
      A: "Client: Econo pack",
      B: "Director: Ali Kazemi",
      C: "Storyboard: Zahra Khorasani",
      D: "Illustration: Zahara Khorasani",
      E: "Animators: Atefe Fazeli ,Vahid Hanid, Ali Kazemi",
      F: "3D Artist: Vahid Hanid",
      G: "Sound Designer: Ali Kazemi",
    }
  },
  {
    id: 5,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/CactusBox.gif",
    name: "Cactus Box",
    url: "/post5",
    description:
      "In this project, we blended 2D animation, 3D elements, and frame-by-frame techniques to build a unified and dynamic visual style. Given the tight deadline, we incorporated AI-assisted tools to speed up parts of the creative process while keeping full artistic control over the final look. Our aim was to create a seamless mix of techniques that brings the world of Cactus Box to life with clarity and energy.",
    src: "https://drive.google.com/file/d/1zPoTqacJT-4pEqkpEkT00WWx4CKbvTN-/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/Storyboard.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/character.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/framestyle.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/Animatic.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/3dcar.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/Smoking.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/Roadcar.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/CactusBox/Transition.gif'
    },
    creators:{
        A: "Client: Cactus Box",
        B: "Art Director: Reza Behnamian",
        C: "Ai: Reza Behnamian",
        D: "FBF Animator: Farsad",
        E: "Animation Supervisor: Atefe Fazeli",
        F: "Animators: Atefe Fazel",
        G: "Composition: Vahid Hanid",
        H: "3D Artist: Ali Molavi, Vahid hanid",
        I: "Manager: Samare Sadeghi",
        J: "Illustration: Reza Behnamian",
        K: "Composer: Amin Ranjbar"
    }
  },
 /*  {
    id: 11,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/SetareYek/dancing.gif",
    name: "Setare Yek",
    url: "/post11",
    description:
      "For this Black Friday project, we created a musical, high-energy motion piece designed to highlight the excitement of the event. We used a wider and more vibrant color palette to boost the visual intensity and reinforce the dynamic rhythm of the soundtrack. Our approach focused on capturing the fast-paced, celebratory feeling of Black Friday while keeping the visuals playful, colorful, and engaging.",
    src: "https://drive.google.com/file/d/1mnWx4WAlZLfnwZpRgY1U4bzWUiB_3ngX/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/SetareYek/Storyboard.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/SetareYek/Spaceship.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/SetareYek/Character.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/SetareYek/Dance.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/SetareYek/Sit.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/SetareYek/jumping.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/SetareYek/payment.gif'
    },
    creators:{
        A: "Client: Setare Yek",
        B: "Art Director: Reza Rafei",
        C: "Animation Supervisor: Ali Kazemi",
        D: "Animators: Atefe Fazeli, Ali Kazemi",
        E: "Composition: Vahid Hanid",
        F: "Illustration: Mojgan Elyasi",
        G: "Composer: Amin Ranjbar"
    }
  }, */
  {
    id: 6,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/NasleOmid.gif",
    name: "Nasle Omid",
    url: "/post6",
    description:
      "Title sequence for a documentary, all within a very short timeline. It was a challenging but rewarding experience, and we are grateful for the teamwork and the creative energy that went into it.",
    src: "https://drive.google.com/file/d/12GEdDgApxz4ssqzf1E2v1-XtLAjFl0yB/preview",
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/Storyboard.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/lab.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/desk.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/logo.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/school.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/table.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/Tunnel.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/NasleOmid/door.gif'
    },
    creators:{
        A: "Art Director: Atefe Fazeli",
        B: "Composition: Vahid Hanid",
        C: "3D Artist: Vahid Hanid",
        D: "Ai: Atefe Fazeli"
    }
  },
  {
    id: 7,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/5-Knowledge-BasedGazelle.gif",
    name: "Knowledge BasedGazelle",
    url: "/post7",
    src: "https://drive.google.com/file/d/1mwoBopIFWCBK9nEd0afWPJcXZP2Ym8D7/preview",
    description:
      "The objective of this 2D motion graphic project is to create an engaging and informative visual representation of Startup Knowledge-Based Gazelle's mission, services, and impact. The animation will serve as a promotional tool to attract potential clients, investors, and partners by showcasing the innovative solutions and expertise we provide to help startups thrive in a competitive landscape.",

      images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/knowledge/Storyboard.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/knowledge/Click.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/knowledge/Map.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/knowledge/Character.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/knowledge/character2.jpg',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/knowledge/map2.jpg',
        
      },
    creators:{
      A: "Client: Knowledge-Based Gazelle",
      B: "Art Director: Reza Behnamian",
      C: "Animation Supervisor: Vahid Hanid",
      D: "Animators: Atefe Fazeli",
      E: "3D Artist: Atefe Fazeli",
      F: "Composition: Vahid Hanid",
      G: "Storyboard: Reza Behnamian",
      H: "Illustration: Reza Behnamian",
      I: "Sound Designer: Muhammad Amin",
    }
  
    },
  
  {
    id: 8,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/6-RankingGame.gif",
    name: "Ranking Game",
    url: "/post8",
    src: "https://drive.google.com/file/d/173W2ZdO3rWEn_CEivC1CuTeJSPnMv3q_/preview",
    description:
      "The objective of this project is to create an engaging 2D motion graphic experience that enhances an online ranking game where players can compete together in real-time. The graphics should not only attract players but also communicate the dynamic and competitive environment of the game.",
      images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/RankingGame/9.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/RankingGame/Challange.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/RankingGame/Characters.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/RankingGame/Erth.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/RankingGame/Knight.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/RankingGame/Revision.jpg',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/RankingGame/Start.gif'
      },
      creators:{
        A: "Client: Ranking Game",
        B: "Art Director: Majid Yousefzadeh",
        C: "Concept Artist: Muhammad",
        D: "Animators: Atefe Fazeli, Vahid Hanid, Ali Kazemi",
        E: "Storyboard: Muhammad",
        F: "Sound Designer: Ali Kazemi",
      }
  },
  {
    id: 9,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/7-Q--Mission.gif",
    name: "Q--Mission",
    url: "/post9",
    src: "https://drive.google.com/file/d/19IJLpuvMKYTU6-gHD9yc3K32937aMoBE/preview",
    description:
      "Q-Mission is at the forefront of technological innovation, specializing in the development of advanced cyber capabilities for governments and organizations. This project aims to create a visually compelling 2D motion graphic that encapsulates the essence of Q-Mission, highlighting its cutting-edge solutions and the impact of its technological advancements on global security.",
      images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Q-Mission/8.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Q-Mission/02.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Q-Mission/03.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Q-Mission/04.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Q-Mission/05.jpg',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Q-Mission/01.jpg',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Q-Mission/Suupeman.gif'

      },
      creators:{
        A: "Client: Q-mission",
        B: "Director: Ali Kazemi",
        C: "Animators: Atefe Fazeli,Ali Kazemi",
        D: "Character Animation: Atefe Fazeli",
        E: "Composition: Vahid Hanid",
        F: "3D Artist: Vahid Hanid",
        G: "Moho Animator: Ali Kazemi",
        H: "Storyboard and Illustration: Zahra Khorasani",
        I: "Sound Designer: Ali Kazemi",
      }
  },
  {
    id: 10,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/8-JustLikeMe.gif",
    name: "Just Like Me",
    url: "/post10",
    src: "https://drive.google.com/file/d/1-EFeFslXKq1rwSz6pWlsDUygJhEO7BOZ/preview",
    description:
      "2D animated short film that explores the theme of declining population through the lens of a single-child family in a near-future society. The film dives into the emotional complexities faced by a family where the focus on one child unfolds challenges, fears, and societal implications due to a demographic imbalance.",
      images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/JustLikeMe/2.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/JustLikeMe/Dad.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/JustLikeMe/FIreman.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/JustLikeMe/Electricity.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/JustLikeMe/Oldman.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/JustLikeMe/Pictureframe.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/JustLikeMe/Sky.gif'

      },
      creators:{
        A: "Client: Roghomi",
        B: "Director: Vahid Hanid",
        C: "Storyboard: Sajjad Grivani",
        D: "Illustration: Sajjad Grivani",
        E: "Animators: Atefe Fazeli",
        F: "Composition: Vahid Hanid",
        G: "Sound Designer: Naser Akrami",
      }
  },
  {
    id: 11,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/9-BaranCharity.gif",
    name: "Baran Charity",
    url: "/post11",
    src: "https://drive.google.com/file/d/1a9d-0NzMojAGG_n-zxlgRcEgBczzjMhA/preview",
    description:
      "The goal is to create an engaging and emotionally resonant 2D motion graphic that highlights the impact of our charity's work. This animation will be used for promotional purposes across social media platforms, our website, and at live events to raise awareness and funds for Baran Charity ",
      images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/BaranCharity/3.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/BaranCharity/Circle.gif ',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/BaranCharity/Coin.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/BaranCharity/Logoreveal.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/BaranCharity/Magnify.gif  ',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/BaranCharity/Magnify.gif  ',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/BaranCharity/a-Coin.gif '

      },
      creators:{
        A: "Client: Baran Charity",
        B: "Art Director: Atefe Fazeli",
        C: "Storyboard: Vahid Hanid",
        D: "Illustration: Vahid Hanid",
        E: "Animators: Atefe Fazeli, Vahid Hanid ",
        F: "Composition: Atefe Fazeli",
      }
  },
  {
    id: 12,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/gif/10-Heev.gif",
    name: "Heev",
    url: "/post12",
    src: "https://drive.google.com/file/d/1rgrA36rWQIabDOqq6nq1LvyA0ILevZ5k/preview",
    description:
      "Heev is a specialized institute dedicated to fostering mental growth and artistic expression in children through a variety of innovative classes. Our mission is to provide a nurturing environment where creativity flourishes, empowering young minds to explore and develop their unique talents.",
      images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Heev/6.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Heev/Dots.gif',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Heev/Elephent-camera.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Heev/Elephent.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Heev/Ends-Dots.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Heev/Output.png',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Heev/STart-cube.gif'

      },
      creators:{
        A: "Client: Heev",
        B: "Storyboard: Vahid Hanid",
        C: "Animation: Atefe Fazeli",
        D: "Composition: Atefe Fazeli",
      }
      
  },
  {
    id: 13,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Home/Dao.gif",
    category: 'Explainer Animation',
    name: "Dao",
    url: "/post13",
    description:
      "A 2D motion piece created for DAO, highlighting its reliable delivery service in every season and weather condition. The animation shows how packages keep moving smoothly, whether it’s sunny, rainy, snowy, or cold.",
    src: "https://drive.google.com/file/d/1eANRX9uxhuiZbUmA3CZLRyBJjqB3uSSp/preview" ,
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Dao/Dao.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Dao/Dao_00032.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Dao/Dao_00396.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Dao/Dao_00686.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Dao/Dao_00888.jpg',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Dao/Season.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Dao/3D.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Dao/snow.gif'
    },
    creators:{
      A: "Client: Dao",
      B: "Animators: Atefeh Fazeli",
      C: "Composition: Vahid Hanid",
      D: "Art Director: Reza Behnamian", 
      E: "Composer: Amin Ranjbar",
      F: "Frame By Frame: Reza Behnamian",
      G: "3D Artist: Vahid Hanid",
      H: "Storyboard: Reza Behnamian",
      I: "Illustration: Reza Behnamian"
    }
  },
  {
    id: 14,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Home/Auto-Abzar.gif",
    category: 'Explainer Animation',
    name: "Auto Abzar",
    url: "/post14",
    description:
      "A 2D motion piece created for Auto Abzar to introduce its toll payment application. The animation uses a simple and fluid visual approach to present the app’s features and make the toll payment process easy to understand.",
    src: "https://drive.google.com/file/d/1UEJR1NT6OsEC2d9MAiCP2m2ggDn1iVU9/preview" ,
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Avareza/Avarezi.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Avareza/mobilephone.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Avareza/phone-hand.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Avareza/scene01.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Avareza/BHS-R.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Avareza/BHScar.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Avareza/inner-2.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Avareza/last.gif'
    },
    creators:{
      A: "Client: Auto Abzar",
      B: "Animators: Atefeh Fazeli, Ali Kazemi",
      C: "Composition: Vahid Hanid",
      D: "Art Director: Reza Rafie", 
      E: "Composer: Amin Ranjbar",
      F: "Illustration: Mojgan Eliasi"
    }
  },
  {
    id: 15,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Home/Drive-Share.gif",
    category: 'Explainer Animation',
    name: "Driveshare",
    url: "/post15",
    description:
      "A short AI-assisted 3D motion piece created for DriveShare. The animation combines stylized 3D visuals with a dynamic cinematic approach to present the brand in a modern and engaging way.",
    src: "https://drive.google.com/file/d/1MUPw41iBH1ov8DwlFsTB9YRFzQAWB1_I/preview" ,
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Driveshare/Driveshare.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Driveshare/Car.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Driveshare/Logo.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Driveshare/Road.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Driveshare/logo_B.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Driveshare/oudoor.jpg',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Driveshare/camera.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Driveshare/logo.gif'
    },
    creators:{
      A: "Client: Driveshare",
      C: "Logo Motion: Vahid Hanid",
      D: "Art Director: Reza Behnamian", 
      E: "Composer: Amin Ranjbar",
      F: "Ai Creator: Reza Behnamian"
    }
  },
   {
    id: 16,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Home/Infrafi.gif",
    category: 'Explainer Animation',
    name: "InfraFi",
    url: "/post16",
    description:
      "A 2D explainer animation created for InfraFi, enhanced with 3D elements to make the concept more engaging and easier to understand. The visual direction focused on simplifying the core idea and communicating it through a clear, dynamic, and cohesive motion system.",
    src: "https://drive.google.com/file/d/1UbFZovqnVrme-4r4bxTLo_CrM_LWNEXj/preview" ,
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Infrafi/Infrafi.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Infrafi/uss-first-0%DB%B1.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Infrafi/4%20copy.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Infrafi/Earth.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Infrafi/3d.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Infrafi/app.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Infrafi/factory.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Infrafi/rotation.gif'
    },
    creators:{
      A: "Client: InfraFi",
      B: "Producer: Abhi",
      C: "3D Artist: Vahid Hanid",
      D: "Art Director: Reza Behnamian", 
      E: "Illustration: Reza Behnamian",
      F: "Animators: Harman, Vahid Hanid ",
      J: "Composer: Amin Ranjbar"
    }
  },
  
  {
    id: 17,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Home/Nature-Lean.gif",
    category: 'Explainer Animation',
    name: "Nature Lean",
    url: "/post17",
    description:
      "A fully 2D motion piece created for Nature Lean, focusing on the brand’s natural and modern identity. The animation uses clean visuals and fluid motion to present the products in a fresh, simple, and engaging way.",
    src: "https://drive.google.com/file/d/1itLZJ7VJac-3HZdgBb6YvnBO434U-DYa/preview" ,
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nature%20Lean/Nature.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nature%20Lean/Nature%20Lean.mp4_snapshot_00.03.529.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nature%20Lean/Nature%20Lean.mp4_snapshot_00.08.774.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nature%20Lean/Nature%20Lean.mp4_snapshot_00.27.515.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nature%20Lean/girl.gif',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nature%20Lean/logo.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nature%20Lean/logo.mp4_snapshot_00.04.689.jpg',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Nature%20Lean/walking.gif'
    },
    creators:{
      A: "Client: Nature Lean",
      B: "Animators: Atefeh Fazeli, Farsad Zaad, Vahid Hanid",
      C: "Composition: Vahid Hanid",
      D: "Art Director: Reza Behnamian", 
      E: "Composer: Farsad Zaad",
      F: "Storyboard: Reza Behnamian",
      J: "Frame By Frame:Reza Behnamian "
    }
  },
  {
    id: 18,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Home/Neo4j.gif",
    category: 'Explainer Animation',
    name: "Neo4j",
    url: "/post18",
    description:
      "A 2D explainer animation created for Neo4j, designed to communicate the core concept in a clear and engaging way. The motion uses simple visual storytelling and fluid transitions to make complex information easier to understand.",
    src: "https://drive.google.com/file/d/1bzrnqLLrJGq6BWvjjorDFnTNayGou_cz/preview" ,
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Ne04j/Ne04j.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Ne04j/neo4j-V07.mp4_snapshot_00.06.902.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Ne04j/neo4j-V07.mp4_snapshot_00.21.319.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Ne04j/neo4j-V07.mp4_snapshot_00.27.637.jpg',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Ne04j/neo4j-V07.mp4_snapshot_00.38.378.jpg',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Ne04j/Entry.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Ne04j/seprated.gif',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Ne04j/texts.gif'
    },
    creators:{
      A: "Client: Neo4j",
      B: "3D Artist: Sadredin",
      C: "Composition: Vahid Hanid",
      D: "Art Director: Reza Behnamian", 
      E: "Composer: Amin Ranjbar",
      F: "Storyboard: Reza Behnamian",
    }
  },
  {
    id: 19,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Home/Realm-Commands.gif",
    category: 'Explainer Animation',
    name: "Realm Commands",
    url: "/post19",
    description:
      "A series of AI-assisted 3D motion pieces created for Realm Commands. The project focused on building a cohesive visual world through stylized 3D scenes, dynamic movement, and a consistent cinematic direction across the entire collection.",
    src: "https://drive.google.com/file/d/1zOYB8qsAN9tZf4eI1qXfxdnxyM0M8OR9/preview" ,
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Realm%20Commands/Realm%20Commands.png',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Realm%20Commands/city9_00290.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Realm%20Commands/door.gif',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Realm%20Commands/intro.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Realm%20Commands/spaceship.jpg',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Realm%20Commands/tunnel.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Realm%20Commands/tunnel2.gif',
        pic8:'https://github.com/vahidhanid14/Website-assets/blob/b9a23d424647a94a04be0c4a26b0bcc070a9ae2f/Realm%20Commands/4000400.png'
    },
    creators:{
      A: "Client: Realm Commands",
      C: "Composition: Vahid Hanid",
      D: "Art Director: Reza Behnamian", 
      E: "Composer: Amin Ranjbar",
      F: "Storyboard: Reza Behnamian",
      J: "3D Artist: Sadredin"
    }
  },
   {
    id: 20,
    image: "https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/Okala.gif",
    category: 'Explainer Animation',
    name: "Okala",
    url: "/post20",
    description:
      "A series of ten 3D animated stories created for Okala’s sales and discount festival campaign. The visuals were designed to present promotional offers in a playful and engaging way, while keeping a consistent look throughout the campaign.",
    src: "https://drive.google.com/file/d/1AMHRUnGHqyTqx4wteWY3FpBARVVvdtVL/preview" ,
    images:{
        pic1:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/3d.gif',
        pic2:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/3dwhite.jpg',
        pic3:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/End.jpg',
        pic4:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/bs.gif',
        pic5:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/first.jpg',
        pic6:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/gray.gif',
        pic7:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/objects.jpg',
        pic8:'https://raw.githubusercontent.com/vahidhanid14/Website-assets/refs/heads/main/Okala/render.jpg'
    },
    creators:{
      A: "Client: Okala",
      C: "Animators: Dot Studio",
      D: "Art Director: Reza Behnamian", 
      E: "Composer: Amin Ranjbar",
      F: "FX and 2D Animator: Vahid Hanid",
      J: "3D Artist: Muhammad Amin",
      H: "Illustration: Reza Behnamian"
    }
  },
];

export const links =[
  
  {
    name: "Icy Monkey",
    url: "/post/1",
  },
/*   {
    name: "Nestlé",
    url: "/post/2",
  },
  {
    name: "AZKI",
    url: "/post/3",
  }, */
  {
    name: "Pixel Network",
    url: "/post/2",
  },
  {
    name: "Subify",
    url: "/post/3",
  },
/*   {
    name: "Divar",
    url: "/post/4",
  }, */
 /*  {
    name: "Folad-1",
    url: "/post/7",
  },
  {
    name: "Folad-2",
    url: "/post/8",
  }, */
  {
    name: "Econo Pak",
    url: "/post/4",
  },
  {
    name: "Cactus Box",
    url: "/post/5",
  },
  /* {
    name: "Setare Yek",
    url: "/post/11",
  }, */
  {
    name: "Nasle Omid",
    url: "/post/6",
  },
  {
    name: "Knowledge BasedGazelle",
    url: "/post/7",
  },{
    name: "Ranking Game",
    url: "/post/8",
  },{
    name: "Q--Mission",
    url: "/post/9",
  },{
    name: "Just Like Me",
    url: "/post/10",
  },{
    name: "Baran Charity",
    url: "/post/11",
  },{
    name: "Heev",
    url: "/post/12",
  },
  {
    name: "Dao",
    url: "/post/13",
  },
  {
    name: "Auto Abzar",
    url: "/post/14",
  },
  {
    name: "Driveshare",
    url: "/post/15",
  },
  {
    name : "InfraFi",
    url:"/post/16"
  },
  {
    name : "Nature Lean",
    url:"/post/17"
  },
  {
    name : "Neo4j",
    url:"/post/18"
  },
   {
    name : "Realm Commands",
    url:"/post/19"
  },
  {
    name : "Okala",
    url:"/post/20"
  },
];
